import '@sokigo/design-system-bootstrap/index.css';
import App from '@sokigo-sbwebb/recommended';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { DndProvider } from 'react-dnd';
import { MultiBackend } from 'react-dnd-multi-backend';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistStore } from 'reduxjs-toolkit-persist';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import Reflex from './Reflex';
import Administration from './administration';
import { store } from './app/store';
import apps from './apps';

const persistor = persistStore(store);
const applications = [Reflex, Administration, ...(apps || [])];

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <DndProvider backend={MultiBackend} options={HTML5toTouch}>
        <App applications={applications} params={{ navbar: { defaultSide: 'top', disableSide: true, defaultTheme: 'off', disableTheme: true }, transformTranslateZ: false }} />
      </DndProvider>
    </PersistGate>
  </Provider>
);
